// ------------------------------------
// Actions
// ------------------------------------

export function getPrice (performer, latlng, location) {
  var url = ''
  if (!latlng) {
    url = '/events?performer=' + performer + '&loc=' + location
  } else {
    url = '/events?performer=' + performer + '&lat=' + latlng.lat + '&lng=' + latlng.lng
  }
  return {
    type: 'GET_PRICE',
    payload: {
      request:{
        url
      }
    }
  }
}

export const actions = {
  getPrice
}

const initialState = { isLoading: false, hasLoaded: false, error: null, events: [] }
export default function homeReducer (state = initialState, action) {
  switch (action.type) {
    case 'GET_PRICE':
      return { isLoading: true, hasLoaded: false, error: null, events: [] }
    case 'GET_PRICE_SUCCESS':
      return { isLoading: false, hasLoaded: true, error: null, events: action.payload.data.data.events }
    case 'GET_PRICE_FAIL':
      return { isLoading: false, hasLoaded: true, events: [], error: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/home.js